module.exports = __webpack_public_path__ + "static/media/logo.de02c5d3.png";